<template>
  <div id="footer" class="container-fluid">
    <div class="foot-line"></div>
    <p class="foot-text">夏乐西瓜</p>
    <p class="foot-text">Copyright © 2025 All Rights Reserved <a href="https://beian.miit.gov.cn">ICP备1111111号</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  //width: 100%;
  height: 100%;
  color: #fff;
  background: #FFFFFF;
  overflow: hidden;
  text-align: center;
  padding: 60px 392px;
}
.foot-line{
  width: 100%;
  height: 0;
  opacity: 1;
  border: 1px solid #E5E5E5;
  margin-bottom: 60px;
}
.foot-text{
  height: 18px;
  font-size: 13px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 15px;
}
.foot-text a{
  color: #333333;
  cursor: pointer;
  text-decoration:none;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 16px;
  margin: 0;
}
.phone{
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFB247;
  line-height: 16px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue